import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH } from 'ish-core/configurations/injection-keys';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { IconModule } from 'ish-core/icon.module';
import { ContentPageletView } from 'ish-core/models/content-view/content-view.model';
import { NavigationCategory } from 'ish-core/models/navigation-category/navigation-category.model';
import { InjectSingle } from 'ish-core/utils/injection';
import { CMSComponent } from 'ish-shared/cms/models/cms-component/cms-component.model';
import { ShellModule } from 'ish-shell/shell.module';

@Component({
  selector: 'custom-cms-main-navigation',
  templateUrl: './cms-main-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, ShellModule, IconModule],
})
export class CMSMainNavigationComponent implements OnInit, CMSComponent {
  private shoppingFacade = inject(ShoppingFacade);
  mainNavigationMaxSubCategoriesDepth = inject<InjectSingle<typeof MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH>>(
    MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH
  );

  readonly pagelet = input<ContentPageletView>(undefined);

  categories$: Observable<NavigationCategory[]>;

  private openedCategories: string[] = [];

  ngOnInit() {
    const pagelet = this.pagelet();
    this.mainNavigationMaxSubCategoriesDepth = pagelet.stringParam('MaxSubCategoriesDepth')
      ? pagelet.numberParam('MaxSubCategoriesDepth')
      : this.mainNavigationMaxSubCategoriesDepth;
    this.categories$ = this.shoppingFacade.navigationCategories$();
  }

  /**
   * Handle sub menu show.
   * Adds hover class to rendered element.
   *
   * @param subMenu The rendered sub menu element.
   */
  subMenuShow(subMenu: HTMLElement) {
    subMenu.classList.add('hover');
  }

  /**
   * Handle sub menu hide.
   * Removes hover class from rendered element.
   *
   * @param subMenu The rendered sub menu element.
   */
  subMenuHide(subMenu: HTMLElement) {
    subMenu.classList.remove('hover');
  }

  /**
   * Indicate if specific category is expanded.
   *
   * @param category The category item.
   */
  isOpened(uniqueId: string): boolean {
    return this.openedCategories.includes(uniqueId);
  }

  /**
   * Toggle category open state.
   *
   * @param category The category item.
   */
  toggleOpen(uniqueId: string) {
    const index = this.openedCategories.findIndex(id => id === uniqueId);
    index > -1 ? this.openedCategories.splice(index, 1) : this.openedCategories.push(uniqueId);
  }
  showFlyout() {
    document.getElementById('quickorderFlyoutView').classList.remove('d-none');
  }
  hideFlyout() {
    document.getElementById('quickorderFlyoutView').classList.add('d-none');
  }
}
